import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { LIST_SINGLECAM_AGENT_POOL_QUERY_KEY } from '@/state/queries/singlecam-agent-admin/use-list-singlecam-agent-pool';
import type {
  PairSingleCamAgentDeviceDto,
  PairSingleCamAgentDeviceResponseDto,
} from '@/types/dtos/singlecam-agent/singlecam-agent-pool.dto';

export function usePairSingleCamAgentDeviceMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: PairSingleCamAgentDeviceDto) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/singlecam-agent/pair-device`;
      return sendJSONRequest({
        url,
        method: METHOD.POST,
        body,
        token: token ?? '',
      }) as Promise<PairSingleCamAgentDeviceResponseDto>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_SINGLECAM_AGENT_POOL_QUERY_KEY] });
    },
  });
}
